import { render, staticRenderFns } from "./YunyingData.vue?vue&type=template&id=063abee8&scoped=true"
import script from "./YunyingData.vue?vue&type=script&lang=js"
export * from "./YunyingData.vue?vue&type=script&lang=js"
import style0 from "./YunyingData.vue?vue&type=style&index=0&id=063abee8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063abee8",
  null
  
)

export default component.exports